const envOrf = 'https://orf01-admin.mapnwea.org/admin/home.seam';
const envOrfBase = 'https://orf01-admin-origin.mapnwea.org';
const userProfileMenu = '/userProfile/menus';
const localHost = 'http://localhost:8080';

// The Start page URL
const startPageUrl = {
  dev: envOrf,
  cert: 'https://perf01-admin.mapnwea.org/admin/home.seam',
  int03: 'https://int03-admin.mapnwea.org/admin/home.seam',
  production: 'https://teach.mapnwea.org/admin/home.seam',
  automation: envOrf,
};

// This represents the client id of the developer application used for OIDC authentication
const devAppClientId = {
  local: 'f1c25d0b7b324e88947e50476dbf2694',
  dev: 'f1c25d0b7b324e88947e50476dbf2694',
  cert: '8348f491d70f4734a69708f9350365eb',
  int03: 'cbd8be2480604c7f82bc51e5badfe28c',
  production: '110a8acb83784f629cac266b45c69cee',
  automation: 'f1c25d0b7b324e88947e50476dbf2694',
};

// This represents the OIDC authority to use
const oidcAuthority = {
  local: 'https://access.auth.dev.nwea.org/cip-edu',
  dev: 'https://access.auth.dev.nwea.org/cip-edu',
  cert: 'https://access.auth.perf.nwea.org/cip-edu',
  int03: 'https://access.auth.int.nwea.org/cip-edu',
  production: 'https://access.auth.nwea.org/cip-edu',
  automation: 'https://access.auth.dev.nwea.org/cip-edu',
};

// For use in building related URLs
const baseURL = {
  local: localHost,
  dev: 'https://orf01-reports.mapnwea.org',
  cert: 'https://cert-reports.mapnwea.org',
  int03: 'https://int03-reports.mapnwea.org',
  production: 'https://reports.mapnwea.org',
  automation: 'http://localhost:8080/reports-landing-page',
};

// By making these values 'null', we tell the authorization code to use the browser's location as the home URL
const homeURL = {
  local: null,
  dev: null,
  cert: null,
  int03: null,
  production: null,
};

// This is the URL used to log out of the application
const logoutUrl = {
  local: 'https://sandbox-api.nwea.org/cl-support/adult/logout',
  dev: 'https://sandbox-api.nwea.org/cl-support/adult/logout',
  cert: 'https://perf-api.nwea.org/cl-support/adult/logout',
  int03: 'https://int-api.nwea.org/cl-support/adult/logout',
  production: 'https://api.nwea.org/cl-support/adult/logout',
};

// This is the base path for reports within a specific environment
const adminBasePath = {
  local: localHost,
  dev: envOrfBase,
  cert: 'https://perf01-admin.mapnwea.org',
  int03: 'https://int03-admin.mapnwea.org',
  production: 'https://teach.mapnwea.org',
  automation: envOrfBase,
};

const apiBasePath = {
  local: localHost,
  dev: 'https://orf01-colo-gateway.nwea.org',
  cert: 'https://perf01-colo-gateway.nwea.org',
  int03: 'https://int03-colo-gateway.nwea.org',
  production: 'https://colo-gateway.nwea.org',
  automation: localHost,
};

// This represents the API endpoint used to get user profile based menus for the main navigation component
const userProfile = {
  local: apiBasePath.local + userProfileMenu,
  dev: apiBasePath.dev + userProfileMenu,
  cert: apiBasePath.cert + userProfileMenu,
  int03: apiBasePath.int03 + userProfileMenu,
  production: apiBasePath.production + userProfileMenu,
  automation: apiBasePath.automation + userProfileMenu,
};

const batchReportBaseUrl = {
  // Update here to point to your DNM: https://<API_GATEWAY_ID>.execute-api.us-west-2.amazonaws.com/dev/batch-reports/v1/
  local: 'https://io9wyg376h.execute-api.us-west-2.amazonaws.com/dev/batch-reports/v1/',
  dev: 'https://io9wyg376h.execute-api.us-west-2.amazonaws.com/dev/batch-reports/v1/',
  cert: 'https://bjjue465ic.execute-api.us-west-2.amazonaws.com/cert/batch-reports/v1/',
  int03: 'https://bj2d0ggirc.execute-api.us-west-2.amazonaws.com/int/batch-reports/v1/',
  production: 'https://3y0jtk6eeh.execute-api.us-west-2.amazonaws.com/prd/batch-reports/v1/',
};
const batchReportFamilyReportReports = {
  local: batchReportBaseUrl.local + 'reports',
  dev: batchReportBaseUrl.dev + 'reports',
  cert: batchReportBaseUrl.cert + 'reports',
  int03: batchReportBaseUrl.int03 + 'reports',
  production: batchReportBaseUrl.production + 'reports',
};

const batchReportFamilyReportDownloadReports = {
  local: batchReportBaseUrl.local + 'downloads',
  dev: batchReportBaseUrl.dev + 'downloads',
  cert: batchReportBaseUrl.cert + 'downloads',
  int03: batchReportBaseUrl.int03 + 'downloads',
  production: batchReportBaseUrl.production + 'downloads',
};

const batchReportRetry = {
  local: batchReportBaseUrl.local + 'retry-reports',
  dev: batchReportBaseUrl.dev + 'retry-reports',
  automation: batchReportBaseUrl.dev + 'retry-reports',
  cert: batchReportBaseUrl.cert + 'retry-reports',
  int03: batchReportBaseUrl.int03 + 'retry-reports',
  production: batchReportBaseUrl.production + 'retry-reports',
};

const mockUserProfile = {
  local: localHost + '/auth/rest/profile',
  automation: 'http://localhost:8080/auth/rest/profile',
};

const Settings = {
  local: () => {
    return {
      START_PAGE_URL: startPageUrl.dev,
      BASE_URL: baseURL.local,
      HOME_URL: homeURL.local,
      LOGOUT_URL: logoutUrl.local,
      OIDC_CLIENT_ID: devAppClientId.local,
      OIDC_AUTHORITY: oidcAuthority.local,
      SILENT_RENEW_URL: `${baseURL.local}/renew.html`,
      USER_PROFILE: userProfile.local,
      USER_MOCK: mockUserProfile.local,
      ADMIN_BASE_PATH: adminBasePath.local,
      API_BASE_PATH: apiBasePath.local,
      URL_BASE_PATH: '/reports-landing-page/',
      END_SESSION_ENDPOINT: 'https://orf01-sso.mapnwea.org/auth/rest/logout',
      BATCH_REPORT_FAMILY_REPORT: batchReportFamilyReportReports.local,
      BATCH_REPORT_FAMILY_REPORT_DOWNLOAD: batchReportFamilyReportDownloadReports.local,
      BATCH_REPORT_RETRY: batchReportRetry.local,
    };
  },

  development: () => {
    return {
      START_PAGE_URL: startPageUrl.dev,
      BASE_URL: baseURL.dev,
      HOME_URL: homeURL.dev,
      LOGOUT_URL: logoutUrl.dev,
      OIDC_CLIENT_ID: devAppClientId.dev,
      OIDC_AUTHORITY: oidcAuthority.dev,
      SILENT_RENEW_URL: `${baseURL.dev}/reports-landing-page/renew.html`,
      USER_PROFILE: userProfile.dev,
      ADMIN_BASE_PATH: adminBasePath.dev,
      API_BASE_PATH: apiBasePath.dev,
      URL_BASE_PATH: '/',
      END_SESSION_ENDPOINT: 'https://orf01-sso.mapnwea.org/auth/rest/logout',
      BATCH_REPORT_FAMILY_REPORT: batchReportFamilyReportReports.dev,
      BATCH_REPORT_FAMILY_REPORT_DOWNLOAD: batchReportFamilyReportDownloadReports.dev,
      BATCH_REPORT_RETRY: batchReportRetry.dev,
    };
  },

  automation: () => {
    return {
      START_PAGE_URL: startPageUrl.automation,
      BASE_URL: baseURL.dev,
      HOME_URL: homeURL.dev,
      OIDC_CLIENT_ID: devAppClientId.automation,
      OIDC_AUTHORITY: oidcAuthority.automation,
      SILENT_RENEW_URL: `${baseURL.automation}/renew.html`,
      USER_PROFILE: userProfile.automation,
      USER_MOCK: mockUserProfile.automation,
      ADMIN_BASE_PATH: adminBasePath.automation,
      API_BASE_PATH: apiBasePath.automation,
      URL_BASE_PATH: '/',
      END_SESSION_ENDPOINT: 'https://orf01-sso.mapnwea.org/auth/rest/logout',
      BATCH_REPORT_RETRY: batchReportRetry.automation,
    };
  },

  orf: () => {
    return {
      START_PAGE_URL: startPageUrl.orf01,
      BASE_URL: baseURL.orf01,
      HOME_URL: homeURL.orf01,
      LOGOUT_URL: logoutUrl.int03,
      OIDC_CLIENT_ID: devAppClientId.orf01,
      OIDC_AUTHORITY: oidcAuthority.orf01,
      SILENT_RENEW_URL: `${baseURL.orf01}/reports-landing-page/renew.html`,
      USER_PROFILE: userProfile.orf01,
      ADMIN_BASE_PATH: adminBasePath.orf01,
      API_BASE_PATH: apiBasePath.orf01,
      URL_BASE_PATH: '/',
      END_SESSION_ENDPOINT: 'https://orf01-sso.mapnwea.org/auth/rest/logout',
      BATCH_REPORT_FAMILY_REPORT: batchReportFamilyReportReports.dev,
      BATCH_REPORT_FAMILY_REPORT_DOWNLOAD: batchReportFamilyReportDownloadReports.dev,
      BATCH_REPORT_RETRY: batchReportRetry.dev,
    };
  },

  // https://int03-admin.mapnwea.org
  integration: () => {
    return {
      START_PAGE_URL: startPageUrl.int03,
      BASE_URL: baseURL.int03,
      HOME_URL: homeURL.int03,
      OIDC_CLIENT_ID: devAppClientId.int03,
      OIDC_AUTHORITY: oidcAuthority.int03,
      SILENT_RENEW_URL: `${baseURL.int03}/reports-landing-page/renew.html`,
      USER_PROFILE: userProfile.int03,
      ADMIN_BASE_PATH: adminBasePath.int03,
      API_BASE_PATH: apiBasePath.int03,
      URL_BASE_PATH: '/',
      END_SESSION_ENDPOINT: 'https://int03-sso.mapnwea.org/auth/rest/logout',
      BATCH_REPORT_FAMILY_REPORT: batchReportFamilyReportReports.int03,
      BATCH_REPORT_FAMILY_REPORT_DOWNLOAD: batchReportFamilyReportDownloadReports.int03,
      BATCH_REPORT_RETRY: batchReportRetry.int03,
    };
  },

  // https://cert-admin.mapnwea.org
  cert: () => {
    return {
      START_PAGE_URL: startPageUrl.cert,
      BASE_URL: baseURL.cert,
      HOME_URL: homeURL.cert,
      OIDC_CLIENT_ID: devAppClientId.cert,
      OIDC_AUTHORITY: oidcAuthority.cert,
      SILENT_RENEW_URL: `${baseURL.cert}/reports-landing-page/renew.html`,
      USER_PROFILE: userProfile.cert,
      ADMIN_BASE_PATH: adminBasePath.cert,
      API_BASE_PATH: apiBasePath.cert,
      URL_BASE_PATH: '/',
      END_SESSION_ENDPOINT: 'https://perf01-sso.mapnwea.org/auth/rest/logout',
      BATCH_REPORT_FAMILY_REPORT: batchReportFamilyReportReports.cert,
      BATCH_REPORT_FAMILY_REPORT_DOWNLOAD: batchReportFamilyReportDownloadReports.cert,
      BATCH_REPORT_RETRY: batchReportRetry.cert,
    };
  },

  // https://teach.mapnwea.org/
  production: () => {
    return {
      START_PAGE_URL: startPageUrl.production,
      BASE_URL: baseURL.production,
      HOME_URL: homeURL.production,
      LOGOUT_URL: logoutUrl.production,
      OIDC_CLIENT_ID: devAppClientId.production,
      OIDC_AUTHORITY: oidcAuthority.production,
      SILENT_RENEW_URL: `${baseURL.production}/reports-landing-page/renew.html`,
      USER_PROFILE: userProfile.production,
      ADMIN_BASE_PATH: adminBasePath.production,
      API_BASE_PATH: apiBasePath.production,
      URL_BASE_PATH: '/',
      END_SESSION_ENDPOINT: 'https://sso.mapnwea.org/auth/rest/logout',
      BATCH_REPORT_FAMILY_REPORT: batchReportFamilyReportReports.production,
      BATCH_REPORT_FAMILY_REPORT_DOWNLOAD: batchReportFamilyReportDownloadReports.production,
      BATCH_REPORT_RETRY: batchReportRetry.production,
    };
  },
};

const envSettings = () => {
  let environmentSettings;
  switch (process.env.ENV_CHOICE) {
    case 'production':
      environmentSettings = Settings.production();
      break;
    case 'integration':
      environmentSettings = Settings.integration();
      break;
    case 'cert':
      environmentSettings = Settings.cert();
      break;
    case 'local':
      environmentSettings = Settings.local();
      break;
    case 'automation':
      environmentSettings = Settings.automation();
      break;
    default:
      environmentSettings = Settings.development();
  }
  return environmentSettings;
};

export default envSettings();
